module.exports = __webpack_public_path__ + "8e2eed3954c0e6e80df31f7501d40f85.svg";